import { ProtectionInfoDTO, RegionMode } from 'api-models'

import { LevelType } from 'layout/navbar/breadcrumbs/types'
import {
	AiProtectionReturnType,
	GetProtectionChecksValuesProps,
	PrepareProtectionPayloadProps,
	ProtectionChecksType
} from './types'

export const getAiProtectionValue = (props: {
	level: LevelType
	enabled?: boolean | null
	inherit?: boolean | null
}): AiProtectionReturnType => {
	const { level, enabled, inherit } = props

	if (level === 'website') {
		return enabled ? 'enabled' : 'disabled'
	}

	if (enabled === false) return 'disabled'

	if (inherit === true) return 'inherit'
	if (enabled === true) return 'enabled'

	return 'inherit'
}

export const DEFAULT_PROTECTION = {
	bots: false,
	bounced: false,
	converted: false,
	geo: false,
	region: ['GLOBAL'],
	region_mode: RegionMode.ALLOW,
	interaction: false,
	ip_range: false,
	multi_target: false,
	non_converting: false,
	placements: false,
	proxy: false,
	vpn: false,
	white_listing: false,
	ip_whitelist: []
} as ProtectionChecksType
export const getProtectionChecksValues = ({
	protection
}: GetProtectionChecksValuesProps): ProtectionChecksType => {
	return {
		bots: protection?.bots || DEFAULT_PROTECTION.bots,
		bounced: protection?.bounced || DEFAULT_PROTECTION.bounced,
		converted: protection?.converted || DEFAULT_PROTECTION.converted,
		geo: protection?.geo || DEFAULT_PROTECTION.geo,
		region_mode: protection?.region_mode || DEFAULT_PROTECTION.region_mode,
		interaction: protection?.interaction || DEFAULT_PROTECTION.interaction,
		ip_range: protection?.ip_range || DEFAULT_PROTECTION.ip_range,
		multi_target: protection?.multi_target || DEFAULT_PROTECTION.multi_target,
		non_converting:
			protection?.non_converting || DEFAULT_PROTECTION.non_converting,
		placements: protection?.placements || DEFAULT_PROTECTION.placements,
		proxy: protection?.proxy || DEFAULT_PROTECTION.proxy,
		region: protection?.region || DEFAULT_PROTECTION.region,
		vpn: protection?.vpn || DEFAULT_PROTECTION.vpn,
		white_listing: !!(
			protection?.ip_whitelist && protection.ip_whitelist.length > 0
		),
		ip_whitelist: protection?.ip_whitelist || DEFAULT_PROTECTION.ip_whitelist
	}
}

export const prepareProtectionPayload = ({
	aiProtection,
	detectionType,
	blockingMode,
	detectionMode,
	protectionChecks
}: PrepareProtectionPayloadProps): ProtectionInfoDTO => {
	return {
		enabled: aiProtection !== 'disabled',
		inherit: aiProtection === 'inherit',
		detection_type: detectionType,
		blocking_mode: blockingMode,
		mode: detectionMode,
		...protectionChecks,
		ip_whitelist: !protectionChecks.white_listing
			? []
			: protectionChecks.ip_whitelist,
		region: protectionChecks.region
	}
}
